var _ImageComponent_instances, _ImageComponent_compRef, _ImageComponent_ps, _ImageComponent_state, _ImageComponent_init;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { BaseComponent } from './BaseComponent';
import { ComponentsNamespaceErrorCode, createComponentsNamespaceError, } from '../errors';
export class ImageComponent extends BaseComponent {
    constructor(compRef, ps) {
        super();
        _ImageComponent_instances.add(this);
        this.compRef = compRef;
        _ImageComponent_compRef.set(this, void 0);
        _ImageComponent_ps.set(this, void 0);
        _ImageComponent_state.set(this, {});
        this.type = 'image';
        __classPrivateFieldSet(this, _ImageComponent_compRef, compRef, "f");
        __classPrivateFieldSet(this, _ImageComponent_ps, ps, "f");
        __classPrivateFieldGet(this, _ImageComponent_instances, "m", _ImageComponent_init).call(this);
    }
    getProp(prop) {
        switch (prop) {
            case 'src': {
                return __classPrivateFieldGet(this, _ImageComponent_state, "f").src;
            }
            default: {
                return null;
            }
        }
    }
    setProp(prop, value) {
        switch (prop) {
            case 'src': {
                __classPrivateFieldGet(this, _ImageComponent_state, "f").src = value;
                const data = __classPrivateFieldGet(this, _ImageComponent_ps, "f").ds.components.data.get(__classPrivateFieldGet(this, _ImageComponent_compRef, "f"));
                // Image and ImageX have different JSON schema,
                // that's why we need to pass different data to verify that it works in both Editors
                // Search for `"Image": {` or `"ImageX": {` in the link below
                // https://github.com/wix-private/monorepo/blob/26a7c8253d85827a4881f7d1b27182574f6764f4/editor_server/wix-html-server/wix-html-editor/wix-html-editor-scripts/src/main/resources/json_schemas/restricted/document_data.json
                if (data.type === 'Image') {
                    __classPrivateFieldGet(this, _ImageComponent_ps, "f").ds.components.data.update(__classPrivateFieldGet(this, _ImageComponent_compRef, "f"), {
                        ...data,
                        uri: value,
                    });
                }
                else {
                    __classPrivateFieldGet(this, _ImageComponent_ps, "f").ds.components.data.update(__classPrivateFieldGet(this, _ImageComponent_compRef, "f"), {
                        ...data,
                        image: {
                            ...data.image,
                            uri: value,
                        },
                    });
                }
                return;
            }
            default: {
                throw createComponentsNamespaceError(ComponentsNamespaceErrorCode.UnknownSetProp, 'image components supports only "src" property');
            }
        }
    }
}
_ImageComponent_compRef = new WeakMap(), _ImageComponent_ps = new WeakMap(), _ImageComponent_state = new WeakMap(), _ImageComponent_instances = new WeakSet(), _ImageComponent_init = function _ImageComponent_init() {
    const data = __classPrivateFieldGet(this, _ImageComponent_ps, "f").ds.components.data.get(__classPrivateFieldGet(this, _ImageComponent_compRef, "f"));
    __classPrivateFieldGet(this, _ImageComponent_state, "f").src = data?.image?.uri || data?.uri;
};
//# sourceMappingURL=ImageComponent.js.map